import { formatErrors2 } from "app/common/schema/formatErrors"
import * as t from "io-ts"

export class DecoderError extends Error {
  public _tag: "DecoderError"

  public errors: t.Errors

  private constructor(errors: t.Errors) {
    super(formatErrors2(errors))
    this._tag = "DecoderError"
    this.errors = errors
  }

  public static of(errors: t.Errors) {
    return new DecoderError(errors)
  }
}
